import { Factory, Layers, Building2, Home, School, Landmark, User, LucideIcon } from "lucide-react";

export interface Segmento {
  slug: string;
  title: string;
  shortLabel: string;
  icon: LucideIcon;
  desc: string;
  solutions: string[];
}

export const segmentos: Segmento[] = [
  {
    slug: "construtoras",
    shortLabel: "Construtoras",
    title: "Construtoras (de Condomínios e Quadras)",
    icon: Factory,
    desc: "Sistemas de Pintura completos para obras novas. Especificação técnica desde a base até o acabamento final, com orientação para cada etapa da construção de quadras em condomínios e empreendimentos.",
    solutions: [
      "Sistemas de Pintura para concreto e asfalto",
      "Especificação técnica completa",
      "Orientação de rendimento e aplicação",
    ],
  },
  {
    slug: "aplicadores",
    shortLabel: "Aplicadores",
    title: "Aplicadores Profissionais",
    icon: Layers,
    desc: "Produtos, fichas técnicas e suporte para execução correta. A Indusport orienta o aplicador na escolha do sistema de pintura mais adequado para cada situação de obra.",
    solutions: [
      "Fichas técnicas detalhadas",
      "Suporte para diagnóstico de base",
      "Orientação de compatibilidade entre camadas",
    ],
  },
  {
    slug: "clubes",
    shortLabel: "Clubes",
    title: "Clubes",
    icon: Building2,
    desc: "Soluções de pintura e recuperação para clubes esportivos com alto volume de uso. Sistemas de Pintura duráveis que reduzem a frequência de manutenção e o tempo parado das quadras.",
    solutions: [
      "Recuperação de quadras existentes",
      "Sistemas de Pintura de alta durabilidade",
      "Redução de paradas para manutenção",
    ],
  },
  {
    slug: "condominios",
    shortLabel: "Condomínios",
    title: "Condomínios",
    icon: Home,
    desc: "Sistemas de Pintura técnicos para quadras de condomínios residenciais e empresariais. Foco em estética, segurança dos moradores e durabilidade contra intempéries.",
    solutions: [
      "Acabamentos com diferentes cores institucionais",
      "Sistemas de Pintura resistentes ao sol e à chuva",
      "Orientação técnica para o síndico/construtora",
    ],
  },
  {
    slug: "escolas",
    shortLabel: "Escolas",
    title: "Escolas",
    icon: School,
    desc: "Pisos esportivos seguros, duráveis e com custo-benefício adequado para uso escolar intenso, em escolas públicas e particulares.",
    solutions: [
      "Sistemas de Pintura resistentes a uso intenso",
      "Segurança e aderência",
      "Custo-benefício para obras escolares",
    ],
  },
  {
    slug: "prefeituras",
    shortLabel: "Prefeituras",
    title: "Prefeitura e Órgãos Públicos",
    icon: Landmark,
    desc: "Sistemas de Pintura para espaços públicos com foco em durabilidade, resistência e redução de retrabalho em obras públicas e licitações.",
    solutions: [
      "Especificação técnica para licitação",
      "Durabilidade comprovada",
      "Orientação técnica para obras públicas",
    ],
  },
  {
    slug: "proprietarios",
    shortLabel: "Quadra Particular",
    title: "Proprietário de Quadra Particular",
    icon: User,
    desc: "Para proprietários de quadras em propriedades particulares que querem o sistema de pintura correto para construir, reformar ou manter sua quadra com qualidade profissional.",
    solutions: [
      "Indicação do sistema de pintura adequado",
      "Orientação para contratação de aplicador",
      "Acabamentos profissionais para uso particular",
    ],
  },
];

export const getSegmentoBySlug = (slug?: string) =>
  segmentos.find((s) => s.slug === slug);
